import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Paper, Tabs, Tab } from '@material-ui/core';

import StartingAtOverride from './StartingAtOverride';
import LeaseOverride from './LeaseOverride';
import PurchaseOverride from './PurchaseOverride';

export const OVERRIDES_ENUMS = {
  STARTING_AT: 0,
  LEASE: 1,
  PURCHASE: 2,
};

class DisplayFeedOverrides extends Component {
  handleTabChange = (evt, activeENUM) => {
    const { values } = this.props;
    this.props.onChange({ ...values, active: activeENUM });
  };

  handleOverrideChange = (field) => (evt) => {
    const { target: { value } } = evt;
    const { active } = this.props.values;
    const update = { [field]: value, active };
    this.props.onChange(update);
  }

  render() {
    const { values } = this.props;
    const { active = OVERRIDES_ENUMS.STARTING_AT } = values;
    return (
      <Paper className={this.props.className}>
        <Paper elevation="1">
          <Tabs
            value={active}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
            onChange={this.handleTabChange}
          >
            <Tab label="Starting At" value={OVERRIDES_ENUMS.STARTING_AT} />
            <Tab label="Lease" value={OVERRIDES_ENUMS.LEASE} />
            <Tab label="Purchase" value={OVERRIDES_ENUMS.PURCHASE} />
          </Tabs>
          <div style={{ padding: 20 }}>
            { active === OVERRIDES_ENUMS.STARTING_AT ? <StartingAtOverride values={values} defaults={this.props.defaultValues} onChange={this.handleOverrideChange} /> : null }
            { active === OVERRIDES_ENUMS.LEASE ? <LeaseOverride values={values} defaults={this.props.defaultValues} onChange={this.handleOverrideChange} /> : null }
            { active === OVERRIDES_ENUMS.PURCHASE ? <PurchaseOverride values={values} defaults={this.props.defaultValues} onChange={this.handleOverrideChange} /> : null }
          </div>
        </Paper>
      </Paper>
    );
  }
}

DisplayFeedOverrides.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  defaultValues: PropTypes.object,
  values: PropTypes.object,
};

DisplayFeedOverrides.defaultProps = {
  onChange: (overrides) => console.warn('Handle onChange for DisplayFeedOverride', overrides),
  values: {
    active: OVERRIDES_ENUMS.STARTING_AT,
  },
  defaultValues: {},
};

export default DisplayFeedOverrides;



// WEBPACK FOOTER //
// ./src/feed-overrides/components/DisplayFeedOverrides.jsx